var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscriber-icon"},[_c('format-money',{staticClass:"subscriber-icon__text",attrs:{"cost":_vm.cost,"font-size":10},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var formattedString = ref.formattedString;
return [_c('div',{staticClass:"subscriber-icon__price"},[_vm._v(" "+_vm._s(formattedString)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }